import { Component, Inject, OnInit, ViewEncapsulation, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '../shared/services/api.service';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { HttpClient } from '@angular/common/http';
import { InternalService } from '../shared/services/internal.service';
import { CookieService } from 'ngx-cookie-service';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  encapsulation: ViewEncapsulation.Emulated
})
export class LoginComponent implements OnInit {
  flag: any = true;
  date: Date = new Date();
  allowedRoles = ['Administrator', 'Admin', 'Agent', 'Moderator', 'Corroborator', 'Marketer'];
  userFlag: any = false;
  constructor(
    private router: Router,
    public apiService: ApiService,
    private internalService: InternalService,
    private cookieService: CookieService,
    public oidcSecurityService: OidcSecurityService, public http: HttpClient,) {

    if (this.cookieService.get('lang') === undefined) {
      this.cookieService.set('lang', '1');
    }
  }

  ngOnInit() {

    // let rolesArray = JSON.parse(this.cookieService.get('currentUserRoles'));

    // if (rolesArray.length > 0) {
    //   this.router.navigate(['/manager/index']);
    // }
    if (this.cookieService.get('currentUserRoles')) {
      const rolesArray = JSON.parse(this.cookieService.get('currentUserRoles'));

     
      for (let item of this.allowedRoles) {
        if (rolesArray.includes(item)) {
          this.userFlag = true;
          break;
        }
      }
      if (rolesArray.length > 0 && this.userFlag) {
        this.router.navigate(['/manager/index']);
      }
    }

    this.cookieService.set('currentUserRoles', JSON.stringify(''));
    this.oidcSecurityService
      .checkAuth().subscribe((auth) => {
        // console.log(this.oidcSecurityService.getToken(),'--------------------');
        //     console.log('is authenticated', auth);
        if (auth) {
          this.apiService.registerConfirm().subscribe((response: any) => {
             console.log('', response);
            this.cookieService.set('profilePic', response.res.profilePic);
            this.cookieService.set('fullName', response.res.name);
            this.cookieService.set('userId', response.res.userId);
            this.cookieService.set('currentUserRoles', JSON.stringify(response.res.role));
            const rolesArray = JSON.parse(this.cookieService.get('currentUserRoles'));
            for (let item of this.allowedRoles) {
              if (rolesArray.includes(item)) {
                this.userFlag = true;
                break;
              }
            }


            if (rolesArray.length === 0 || !this.userFlag) {
              this.router.navigate(['/forbidden']);
            } else {
              this.router.navigate(['/manager/index']);
            }
          });
        } else {
          this.flag = false;
        }
      }
      );





    // this.apiService.apiCall('get','/api/Account/RegisterConfirm',{}).subscribe((response: any) => {
    //   // console.log('',response);
    //   this.cookieService.set('fullName', response.res.name);
    //   this.cookieService.set('currentUserRoles', JSON.stringify(response.res.role));
    // })


    // this.oidcSecurityService
    //   .checkAuth().subscribe((auth) => {
    //     console.log('is authenticated', auth);
    //     if (auth) {
    //       this.apiService.registerConfirm().subscribe((response: any) => {
    //         // console.log('RegisterConfirm', response);
    //         this.cookieService.set('currentUserRoles', JSON.stringify(response.res.role));
    //         this.cookieService.set('userId', response.res.id);
    //         const rolesArray = JSON.parse(this.cookieService.get('currentUserRoles'));
    //         this.cookieService.set('fullName', response.res.name);
    //         if (rolesArray.length === 0) {
    //           this.router.navigate(['/forbidden']);
    //         } else {
    //           this.router.navigate(['/manager/index']);
    //         }
    //       });
    //       this.oidcSecurityService.userData$.subscribe((res: any) => {
    //         console.log(res, '------------------------');
    //       });
    //     } else {
    //       this.flag = false;
    //
    //       // this.login();
    //     }
    //   }
    // );

  }

  login() {
    this.oidcSecurityService.authorize();
  }

}

